import { Nullable } from '../../types';

import styles from './StoredCreditCards.module.scss';

type CreditCardNumberProps = {
  lastFourDigits: Nullable<string>;
};

/**
 * Display 16 dots which stands for the credit card number.
 * If lastFourDigits is a non-empty string, display 12 dots + these lastFourDigits.
 */
const MaskedCardNumber: React.FC<CreditCardNumberProps> = ({ lastFourDigits }) => {
  // If we have the lastFourDigits, then we display them. Otherwise, we display only dots.
  const indexesBlock = lastFourDigits ? [1, 2, 3] : [1, 2, 3, 4];
  return (
    <div>
      {indexesBlock.map((indexBlock) => (
        <span className={styles.creditCardDots} key={indexBlock}>
          {[1, 2, 3, 4].map((indexDot) => (
            <span key={indexDot} className={styles.creditCardDot}>
              &#11044;
            </span>
          ))}
        </span>
      ))}
      {lastFourDigits && <span>{lastFourDigits}</span>}
    </div>
  );
};

export default MaskedCardNumber;
